<template>
    <div>
        <v-label :focused="focused || hasError" :color="validationState">{{label}}</v-label>
        <div :class="containerClass">
        <editor :init="init" ref="editor" class="editor" @onInit="onReady" @onChange="emitChange" 
            @onBlur="focused = false" @onFocus="focused = true" :style="'min-height: '+this.minHeight+'px'"
            v-model="content" ></editor>
        </div>
     <VMessages class="mt-1" :value="errorBucket" color="error"/>
    </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
import VInput from 'vuetify/lib/components/VInput/VInput.js';

export default {
    name:"DataVarianceEditor",
    props:{
        baseUrl: {
        type: String,
        default: process.env.BASE_URL
        },
        value:{
        type: String,
        default: ""  
        },
        label:{
        type: String,
        default: ""  
        },
        minHeight:{
            type:Number,
            value:300
        },
        height:{
            type:Number,
            value:300
        }
    },
    components:{Editor},
    extends: VInput,
    data(){
        return {
            content:"",
            editor:null,
            focused:false,
            init: {
            menubar: false,
            inline: false,
            branding: false, 
            statusbar:false,
            plugins: [
                'link',
                'lists',
                'autolink',
                'wordcount',
                'autosave',
                'save',
                'hr',
                'insertdatetime',
                'table'
            ],
            toolbar:false,
            browser_spellcheck: true,
            autosave_ask_before_unload: true,
            autosave_interval: "20s",
            skin:"custom",
            autosave_prefix: "tinymce-autosave-{path}{query}-{id}-",
            min_height:this.minHeight,
            height:this.height
          }
        }
    },
    watch:{
        value(val){
            if(val != null && this.content != val){
                this.content = val;
            }
        }
    },
    computed:{
        containerClass(){
            let style="editor ml-0 mt-1";
            if(this.focused){
                style += " editWithBorder";
            }

            if(this.hasError){
                style +=" errorBorder";
            }
            return style;
        }
    },
    created(){
        if(this.value){
            this.content = this.value
        }
        this.emitChange();
    },
    methods:{
        emitChange(){
            //remove table border style if exists
            this.content = this.content.replace(/border="0"/g,"");
            this.$emit("input",this.content);
        },
         onReady (e) {
            this.editor = e.target;      
        },
    }
}
</script>
<style lang="scss" scoped>
.editWithBorder{
    border:2px var(--v-primary-base) solid;
}

.errorBorder{
    border:2px red solid !important;
}


</style>